import styled from "styled-components";

export const Wrapper = styled.div`
  table {
    border: 1px solid grey;
    width: 100%;
    border-collapse:collapse;
  }
  td {
    padding: 0;
    border: 1px solid grey;
    text-align: center;
  }
  th {
    background-color: ${({ theme }) => theme.default.color.backgrounds.light};
    border: 1px solid grey;
  }
`;
